import React, {} from 'react';
import { ReactEditor, useSlateStatic } from 'slate-react';

import serverInterface from 'server-interface';

import HelptapEditor from '../../../helpers';
import BaseElement from '../../base';
import InlineChromiumBugfix from '../../link/inline-chromium-bug-fix';

import GenericEventEditor from './generic/v2';

function EventEditor(props) {

  const element = props.element;
  const attributes = element.attributes || element.eventOptions;

  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, props.element);

  async function getEvent(postId) {

    return serverInterface.startup.community.events.getEventByPostId(postId);

  }

  async function updateEvent(postId, event) {

    return serverInterface.startup.community.events.updateEventByPostId(postId, event);

  }

  async function validator(postId, event) {

    return serverInterface.startup.community.events.validateUpdateEventByPostIdInput(postId, event);

  }

  function renderEventEditor() {

    const properties = {
      postId: attributes.postId,
      error: element.error,
      recurField: false,
      getEvent,
      updateEvent,
      validator,
      deleteEditorNode() {
        HelptapEditor.deleteNodeByPath(editor, elementPath);
      },
      resetError() {
        HelptapEditor.setNodeError(editor, elementPath, void 0);
      }
    };

    return <div {...props.attributes}>
      <GenericEventEditor {...properties} />
      <InlineChromiumBugfix />
      {props.children}
      <InlineChromiumBugfix />
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      placeholder: '',
      className: 'event-template-editor-main event-editor-main',
      contentEditable: false
    };

    return <BaseElement {...baseElementProperties}>
      {renderEventEditor()}
    </BaseElement>;

  }

  return renderMain();

}

export default EventEditor;